import API from 'services/api';

export const getProfile = async () => {
  return await API.get(`/user/myself`);
};

export const editProfile = async (data: any) => {
  return await API.put(`/user/myself`, data);
};
